export function computeJobTabStats(filteredCards) {
  return {
    total: filteredCards.length,
    booked: filteredCards.filter((c) => c.status === 'Booked').length,
    pending: filteredCards.filter((c) => c.status === 'Pending').length,
    /** Third state in mock data is `Open`; shown as Failed in the summary strip. */
    failed: filteredCards.filter((c) => c.status === 'Open').length,
  };
}

/** Issues use the same four slots: Pending = warnings, Failed = errors, Booked unused (0). */
export function computeIssuesTabStats(filteredIssues) {
  return {
    total: filteredIssues.length,
    booked: 0,
    pending: filteredIssues.filter((i) => i.severity === 'warning').length,
    failed: filteredIssues.filter((i) => i.severity === 'error').length,
  };
}
